import { MouseEvent as ReactMouseEvent } from "react";

/**
 * 获取当前鼠标点击的单元格
 * @param e 鼠标点击事件
 * @returns
 */
export const getCellByLineMousedown = (
  e: ReactMouseEvent<HTMLDivElement, MouseEvent>
) => {
  const els = document.elementsFromPoint(e.clientX, e.clientY);
  return els.find((el) => el.nodeName === "TD");
};

/**
 * 判断拖拽线是否在单元格内
 * @param e 鼠标事件
 * @returns
 */
export const isLineInCell = (
  e: ReactMouseEvent<HTMLDivElement, MouseEvent>,
  type: "row" | "col"
) => {
  const lineEle = e.currentTarget;
  const tdEle = getCellByLineMousedown(e);
  // 这里表示是在table的边缘
  if (!tdEle) return false;
  const lineRect = lineEle.getBoundingClientRect();
  const tdRect = tdEle.getBoundingClientRect();
  return type === "col"
    ? lineRect.left > tdRect.left &&
        lineRect.left + lineRect.width < tdRect.left + tdRect.width
    : lineRect.top > tdRect.top &&
        lineRect.top + lineRect.height < tdRect.top + tdRect.height;
};
